module.exports = __webpack_public_path__ + "static/IMG_1593-1406cb6346c3ac9f894314010a66751a.jpg";